module.exports = "/_next/static/images/418d614a4dd38154f9f5ae6820835dbb-hand-coin.svg.webp";